<template>
  <div class="container">
    <!-- 모바일 앱에서 회원가입시에 로그를 뺌 -->
    <template v-if="fromParams?.p !== 'app'">
      <dot-incorporation-logo />
    </template>
    <router-view />
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import "@/assets/css/layout.css";
import "@/assets/css/contents.css";
import { $global } from "@/dot-ui/index.js";

const DotIncorporationLogo = defineAsyncComponent(() =>
  import("@/components/molecules/DotIncorporationLogo.vue")
);

export default {
  data() {
    return {
      fromParams: {},
    };
  },
  components: {
    DotIncorporationLogo,
  },
  created() {
    this.fromParams = $global.getUrlParams();
  },
};
</script>
<style></style>
